import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { userManagementBaseUrl, userManagement } from "../endpoints";

export const openingBalanceFinanceService = createApi({
  reducerPath: "openingBalanceFinanceService",
  baseQuery: fetchBaseQuery({ baseUrl: userManagementBaseUrl }),
  tagTypes: ["openingBalanceFinance"],
  endpoints: (builder) => ({
    getAllOpeningBalanceFinance: builder.mutation({
      query: (body) => ({
        url: `${userManagement.openingBalanceFinanceController.getAllOpeningBalanceFinance}/${body.payload.page}/${body.payload.size}?orderBy=${body.payload.orderBy}`,
        method: "GET",
         headers: { Authorization: `Bearer ${body.token}` },
      }),
    }),
    searchOpeningBalanceFinance: builder.mutation({
      query: (body) => ({
        url: `${userManagement.openingBalanceFinanceController.searchOpeningBalanceFinance}`,
        method: "POST",
        body: body.payload,
         headers: { Authorization: `Bearer ${body.token}` },
      }),
    }),
    saveOpeningBalanceFinance: builder.mutation({
      query: (body) => ({
        url: `${userManagement.openingBalanceFinanceController.saveOpeningBalanceFinance}`,
        method: "POST",
        body: body.payload,
         headers: { Authorization: `Bearer ${body.token}` },
      }),
    }),
    updateOpeningBalanceFinance: builder.mutation({
      query: (body) => ({
        url: `${userManagement.openingBalanceFinanceController.updateOpeningBalanceFinance}/${body.id}`,
        method: "PUT",
        body: body.payload,
         headers: { Authorization: `Bearer ${body.token}` },
      }),
    }),
    deleteOpeningBalanceFinance: builder.mutation({
      query: (body) => ({
        url: `${userManagement.openingBalanceFinanceController.deleteOpeningBalanceFinance}/${body.id}`,
        method: "DELETE",
         headers: { Authorization: `Bearer ${body.token}` },
      }),
    }),
    getOpeningBalanceFinanceById: builder.mutation({
      query: (body) => ({
        url: `${userManagement.openingBalanceFinanceController.getOpeningBalanceFinanceById}/${body.id}`,
        method: "GET",
         headers: { Authorization: `Bearer ${body.token}` },
      }),
    }),
    getAllOpeningBalanceFinanceList: builder.mutation({
      query: (body) => ({
        url: `${userManagement.openingBalanceFinanceController.getAllOpeningBalanceFinanceList}`,
        method: "GET",
         headers: { Authorization: `Bearer ${body.token}` },
      }),
    }),
    uploadBulkOpeningBalanceFinance: builder.mutation({
      query: (body) => ({
        url: `${userManagement.openingBalanceFinanceController.uploadBulkOpeningBalanceFinance}`,
        method: "POST",
        body: body.payload,
         headers: { Authorization: `Bearer ${body.token}` },
      }),
    }),
  }),
});

export const {
  useGetAllOpeningBalanceFinanceMutation,
  useSearchOpeningBalanceFinanceMutation,
  useSaveOpeningBalanceFinanceMutation,
  useUpdateOpeningBalanceFinanceMutation,
  useDeleteOpeningBalanceFinanceMutation,
  useGetOpeningBalanceFinanceByIdMutation,
  useGetAllOpeningBalanceFinanceListMutation,
  useUploadBulkOpeningBalanceFinanceMutation,
} = openingBalanceFinanceService;
